<template lang="html">
  <v-row>
  <div class="mr-2">{{header}}</div>
    <v-menu offset-y class="mr-2" :disabled="readonly">
      <template v-slot:activator="{ on }">
      <v-card
        class="pr-0 pl-1"
        v-on="on"
        :style="`border-radius: 5px; margin-bottom: 3px; ${width? `width: ${width}` : ''}`"
        :color="`${color}`"
        >
        <v-layout align-center>
        <v-icon v-if="icon" class="dataFieldIcon" color="black">{{icon}}</v-icon>
        <div v-if="option_color" :class="`option-color ${value} ${(!value || value.includes('lighten') || value.includes('darken'))? '':'lighten-1'}`"/>
        <v-icon
          class="icon"
          v-else-if="option_icon && isStandardIcon(value)"
          :color="textcolor"
          >
          {{value}}
        </v-icon>
        <svg-icon
          v-else-if="option_icon && value"
          class="svg-icon"
          :name="value"
          :size="20"
          :style="`fill: ${textcolor}; height: 20px`"
        />
        <div v-else-if="value" :style="`color: ${textcolor}; cursor: pointer`">{{value}}</div>
        <v-spacer/>
        <v-icon v-if="!readonly" :size="20" :color="textcolor">keyboard_arrow_down</v-icon>
        </v-layout>
      </v-card>
    </template>
    <v-card class="pr-2 pl-2" :style="limit_height ? 'border-radius: 5px; max-height:400px;' : 'border-radius: 5px;'" :color="`${color}`">
      <div
        class="options"
        v-for="(option, index) in options"
        @click="$emit('changeValue', option)"
        :key="index"
        >
        <div v-if="option_color" :class="`option-color ${option.value} ${option.value.includes('lighten') || option.value.includes('darken')? '':'lighten-1'}`"/>
        <v-icon
          class="icon"
          v-else-if="option_icon && isStandardIcon(option.value)"
          :color="textcolor"
          >
          {{option.value}}
        </v-icon>
        <svg-icon
          v-else-if="option_icon && option.value"
          class="svg-icon"
          :name="option.value"
          :size="20"
          :style="`fill: ${textcolor}; height: 20px`"
        />
        <div v-else-if="option.name" :style="`color: ${textcolor}`">{{option.name}}</div>
      </div>
    </v-card>
    </v-menu>
  </v-row>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: [
    'icon',
    'header',
    'value',
    'placeholder',
    'color',
    'readonly',
    'textcolor',
    'options',
    'option_color',
    'option_icon',
    'width',
    'limit_height'
  ],
  computed: {
    ...mapGetters('TWorkPackage', [
      'isStandardIcon'
      ],
    ),
  }
}
</script>

<style lang="css" scoped>
  .options {
    cursor: pointer;
    text-align: center;
    z-index: 1;
  }
  .options:hover {
    background-color: grey;
  }
  .dataFieldIcon {
    zoom: 1.2;
  }
  .option-color {
    height: 18px;
    width: 24px;
    margin: 3px;
    border-radius: 3px;
  }

</style>
